import type { CopyShape } from "@tami/core/intl";

import type { CALENDAR_SCRIPT_COPY_PT_BR } from "../calendar-script.copy";

export const CALENDAR_SCRIPT_COPY_EN_US: CopyShape<typeof CALENDAR_SCRIPT_COPY_PT_BR> = {
  calIntro: {
    narrative: "Plan the whole month on a drag-and-drop calendar — posts, deliverables and appointments in one view.",
  },
  calGrid: {
    narrative: "Organize content by month or week, with the date, time and format of each post.",
    callout: "Drag-and-drop calendar: brand deals and organic posts in different colors so you never mix them up.",
  },
  calEventDetail: {
    narrative: "Click an appointment and see what matters: when, with whom and what was agreed.",
    callout: "Meeting, shoot, call with the brand — appointments live right next to your content.",
  },
  calPostDetail: {
    narrative:
      "And clicking a post opens its details: what stage it's in, when it goes live, what it's worth, script, notes and attachments.",
    callout: "Stage, due date, amount and script on one screen — no digging through other pages.",
  },
  calCreate: {
    narrative: "The add button asks what it is first: an appointment or a post.",
    callout: "Two different things, two different paths — the tile color is the color the item will have.",
  },
  calEventForm: {
    narrative: "For an appointment you set the day, time and who's joining — and it goes on the calendar right away.",
    callout: "Start and end time, attendees and location: just enough, no long form.",
  },
  calPostForm: {
    narrative: "And a post opens the same planner as the Content hub, already on the date you picked.",
    callout: "The same form as the Content hub — the calendar doesn't make up a different way.",
  },
  calOverview: {
    narrative: "Mark content as posted and track your progress through the month.",
  },
  calSidebar: {
    narrative: "Ideas and to-dos without a date stay separate — so no task gets lost in the rush.",
    callout: "The 'don't forget' list: ideas and to-dos that don't have a date yet.",
  },
  calOutro: {
    narrative: "Write scripts, add links and export — all without leaving the calendar.",
  },
};
